module.exports = __webpack_public_path__ + "static/6.3_kush_and_other_african_kingdoms-8c31798e08be083471af088803c6ecc1.pdf";